/**
 * shell-routes.ts — AUTO-GENERATED, DO NOT EDIT
 *
 * Generated by: scripts/generate-shell-routes.ts
 * Source: ir-snapshot.json + sidebar-snapshot.json
 * Generated at: 2026-06-27T15:36:53.985Z
 * Endpoints: 216
 */

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface ShellRoute {
  method: string;
  path: string;
  desc: string;
}

export interface ShellCategory {
  label: string;
  slug: string;
  routes: ShellRoute[];
}

// ---------------------------------------------------------------------------
// Categorised routes (for the `routes` command display)
// ---------------------------------------------------------------------------

export const SHELL_CATEGORIES: ShellCategory[] = [
  {
    "label": "Core",
    "slug": "core",
    "routes": [
      {
        "method": "POST",
        "path": "/auth/forgot-password",
        "desc": "Request password reset email"
      },
      {
        "method": "POST",
        "path": "/auth/login",
        "desc": "Login with username and password"
      },
      {
        "method": "POST",
        "path": "/auth/logout",
        "desc": "Logout"
      },
      {
        "method": "GET",
        "path": "/auth/me",
        "desc": "Get current user"
      },
      {
        "method": "POST",
        "path": "/auth/password",
        "desc": "Change password"
      },
      {
        "method": "POST",
        "path": "/auth/refresh",
        "desc": "Refresh access token"
      },
      {
        "method": "POST",
        "path": "/auth/register",
        "desc": "Register a new user and organisation"
      },
      {
        "method": "POST",
        "path": "/auth/reset-password",
        "desc": "Reset password with token"
      },
      {
        "method": "GET",
        "path": "/auth/reset-password/validate",
        "desc": "Validate a password reset token"
      },
      {
        "method": "DELETE",
        "path": "/auth/totp",
        "desc": "Disable TOTP"
      },
      {
        "method": "POST",
        "path": "/auth/totp/enable",
        "desc": "Verify and enable TOTP"
      },
      {
        "method": "POST",
        "path": "/auth/totp/setup",
        "desc": "Generate TOTP secret for setup"
      },
      {
        "method": "POST",
        "path": "/auth/totp/verify",
        "desc": "Verify TOTP code"
      },
      {
        "method": "POST",
        "path": "/auth/verify-email",
        "desc": "Verify email with token"
      },
      {
        "method": "POST",
        "path": "/auth/verify-email/send",
        "desc": "Send verification email to current user"
      },
      {
        "method": "GET",
        "path": "/auth/verify-email/status",
        "desc": "Check email verification status"
      },
      {
        "method": "GET",
        "path": "/organisation",
        "desc": "Get organisation details and settings"
      },
      {
        "method": "PUT",
        "path": "/organisation",
        "desc": "Update organisation profile"
      },
      {
        "method": "POST",
        "path": "/organisation/accounting-period",
        "desc": "Set the accounting period from Companies House"
      },
      {
        "method": "POST",
        "path": "/organisation/accounting-period/preview",
        "desc": "Preview the accounting period from Companies House"
      },
      {
        "method": "PUT",
        "path": "/organisation/settings",
        "desc": "Update organisation settings"
      }
    ]
  },
  {
    "label": "Accounting",
    "slug": "accounting",
    "routes": [
      {
        "method": "GET",
        "path": "/accounts",
        "desc": "List chart of accounts"
      },
      {
        "method": "POST",
        "path": "/accounts",
        "desc": "Create an account"
      },
      {
        "method": "GET",
        "path": "/accounts/types",
        "desc": "Get account types with counts"
      },
      {
        "method": "GET",
        "path": "/accounts/:id",
        "desc": "Get account details"
      },
      {
        "method": "PUT",
        "path": "/accounts/:id",
        "desc": "Update an account"
      },
      {
        "method": "DELETE",
        "path": "/accounts/:id",
        "desc": "Delete an account"
      },
      {
        "method": "GET",
        "path": "/accounts/:id/balance",
        "desc": "Get account balance"
      },
      {
        "method": "GET",
        "path": "/transactions",
        "desc": "List transactions"
      },
      {
        "method": "POST",
        "path": "/transactions",
        "desc": "Create a transaction"
      },
      {
        "method": "GET",
        "path": "/transactions/account/:accountId",
        "desc": "Get account ledger"
      },
      {
        "method": "GET",
        "path": "/transactions/:id",
        "desc": "Get transaction details"
      },
      {
        "method": "DELETE",
        "path": "/transactions/:id",
        "desc": "Delete a draft transaction"
      },
      {
        "method": "PATCH",
        "path": "/transactions/:id/categorise",
        "desc": "Categorise a transaction"
      },
      {
        "method": "PATCH",
        "path": "/transactions/:id/reconcile",
        "desc": "Reconcile a transaction"
      },
      {
        "method": "PATCH",
        "path": "/transactions/:id/status",
        "desc": "Update transaction status"
      },
      {
        "method": "POST",
        "path": "/transactions/:id/suggest-category",
        "desc": "Suggest transaction category"
      },
      {
        "method": "GET",
        "path": "/invoices",
        "desc": "List invoices"
      },
      {
        "method": "POST",
        "path": "/invoices",
        "desc": "Create an invoice"
      },
      {
        "method": "POST",
        "path": "/invoices/preview",
        "desc": "Preview invoice calculations"
      },
      {
        "method": "GET",
        "path": "/invoices/:id",
        "desc": "Retrieve an invoice"
      },
      {
        "method": "PUT",
        "path": "/invoices/:id",
        "desc": "Update a draft invoice"
      },
      {
        "method": "DELETE",
        "path": "/invoices/:id",
        "desc": "Delete a draft invoice"
      },
      {
        "method": "POST",
        "path": "/invoices/:id/email",
        "desc": "Send invoice via email"
      },
      {
        "method": "POST",
        "path": "/invoices/:id/payment",
        "desc": "Record a payment"
      },
      {
        "method": "POST",
        "path": "/invoices/:id/payment/reverse",
        "desc": "Reverse a payment"
      },
      {
        "method": "GET",
        "path": "/invoices/:id/pdf",
        "desc": "Download invoice as PDF"
      },
      {
        "method": "PATCH",
        "path": "/invoices/:id/status",
        "desc": "Update invoice status"
      },
      {
        "method": "GET",
        "path": "/quotes",
        "desc": "List quotes"
      },
      {
        "method": "POST",
        "path": "/quotes",
        "desc": "Create a new quote"
      },
      {
        "method": "POST",
        "path": "/quotes/preview",
        "desc": "Preview quote calculations"
      },
      {
        "method": "GET",
        "path": "/quotes/:id",
        "desc": "Get quote details"
      },
      {
        "method": "PUT",
        "path": "/quotes/:id",
        "desc": "Update a draft quote"
      },
      {
        "method": "DELETE",
        "path": "/quotes/:id",
        "desc": "Delete a draft quote"
      },
      {
        "method": "POST",
        "path": "/quotes/:id/convert",
        "desc": "Convert an accepted quote to a sales invoice"
      },
      {
        "method": "PATCH",
        "path": "/quotes/:id/status",
        "desc": "Update quote status"
      },
      {
        "method": "GET",
        "path": "/credit-notes",
        "desc": "List credit notes"
      },
      {
        "method": "POST",
        "path": "/credit-notes",
        "desc": "Create a credit note"
      },
      {
        "method": "GET",
        "path": "/credit-notes/:id",
        "desc": "Retrieve a credit note"
      },
      {
        "method": "POST",
        "path": "/credit-notes/:id/allocations",
        "desc": "Allocate a credit note to an invoice"
      },
      {
        "method": "POST",
        "path": "/credit-notes/:id/allocations/:alloc_id/reverse",
        "desc": "Reverse a credit-note allocation"
      },
      {
        "method": "POST",
        "path": "/credit-notes/:id/issue",
        "desc": "Issue a credit note"
      },
      {
        "method": "POST",
        "path": "/credit-notes/:id/void",
        "desc": "Void a credit note"
      },
      {
        "method": "GET",
        "path": "/contacts",
        "desc": "List contacts"
      },
      {
        "method": "POST",
        "path": "/contacts",
        "desc": "Create a contact"
      },
      {
        "method": "GET",
        "path": "/contacts/:id",
        "desc": "Get contact details"
      },
      {
        "method": "PUT",
        "path": "/contacts/:id",
        "desc": "Update a contact"
      },
      {
        "method": "DELETE",
        "path": "/contacts/:id",
        "desc": "Deactivate a contact"
      },
      {
        "method": "GET",
        "path": "/contacts/:id/summary",
        "desc": "Get contact financial summary"
      },
      {
        "method": "GET",
        "path": "/reports/aged-creditors",
        "desc": "Aged Creditors Report"
      },
      {
        "method": "GET",
        "path": "/reports/aged-debtors",
        "desc": "Aged Debtors Report"
      },
      {
        "method": "GET",
        "path": "/reports/balance-sheet",
        "desc": "Balance Sheet"
      },
      {
        "method": "GET",
        "path": "/reports/dashboard-summary",
        "desc": "Dashboard summary"
      },
      {
        "method": "GET",
        "path": "/reports/ledger-verification",
        "desc": "Ledger verification"
      },
      {
        "method": "GET",
        "path": "/reports/periods",
        "desc": "List financial periods"
      },
      {
        "method": "GET",
        "path": "/reports/periods/:id",
        "desc": "Get financial period details"
      },
      {
        "method": "GET",
        "path": "/reports/profit-loss",
        "desc": "Profit & Loss"
      },
      {
        "method": "GET",
        "path": "/reports/trial-balance",
        "desc": "Trial Balance"
      },
      {
        "method": "GET",
        "path": "/reports/vat",
        "desc": "VAT Return Summary"
      }
    ]
  },
  {
    "label": "Banking",
    "slug": "banking",
    "routes": [
      {
        "method": "GET",
        "path": "/bank-accounts",
        "desc": "List bank accounts"
      },
      {
        "method": "POST",
        "path": "/bank-accounts",
        "desc": "Create a bank account"
      },
      {
        "method": "GET",
        "path": "/bank-imports",
        "desc": "List bank imports"
      },
      {
        "method": "POST",
        "path": "/bank-imports/upload",
        "desc": "Upload bank statement"
      },
      {
        "method": "GET",
        "path": "/bank-imports/:id",
        "desc": "Get bank import details"
      },
      {
        "method": "DELETE",
        "path": "/bank-imports/:id",
        "desc": "Delete a bank import"
      },
      {
        "method": "POST",
        "path": "/bank-imports/:id/confirm",
        "desc": "Confirm bank import"
      },
      {
        "method": "POST",
        "path": "/bank-imports/:id/remap",
        "desc": "Remap bank import columns"
      },
      {
        "method": "GET",
        "path": "/categorisation-rules",
        "desc": "List categorisation rules"
      },
      {
        "method": "POST",
        "path": "/categorisation-rules",
        "desc": "Create categorisation rule"
      },
      {
        "method": "POST",
        "path": "/categorisation-rules/categorise-row",
        "desc": "Create rule from import categorisation"
      },
      {
        "method": "GET",
        "path": "/categorisation-rules/global",
        "desc": "List global consensus rules with tenant account resolution"
      },
      {
        "method": "POST",
        "path": "/categorisation-rules/reorder",
        "desc": "Reorder rules by updating priorities"
      },
      {
        "method": "POST",
        "path": "/categorisation-rules/test",
        "desc": "Test a value against categorisation rules"
      },
      {
        "method": "PATCH",
        "path": "/categorisation-rules/:id",
        "desc": "Update categorisation rule"
      },
      {
        "method": "DELETE",
        "path": "/categorisation-rules/:id",
        "desc": "Delete categorisation rule"
      }
    ]
  },
  {
    "label": "Company",
    "slug": "company",
    "routes": [
      {
        "method": "GET",
        "path": "/directors",
        "desc": "List directors and shareholders"
      },
      {
        "method": "POST",
        "path": "/directors",
        "desc": "Add a director or shareholder"
      },
      {
        "method": "GET",
        "path": "/directors/:id",
        "desc": "Get director details"
      },
      {
        "method": "PATCH",
        "path": "/directors/:id",
        "desc": "Update director details"
      },
      {
        "method": "DELETE",
        "path": "/directors/:id",
        "desc": "Resign a director"
      },
      {
        "method": "GET",
        "path": "/director-loans",
        "desc": "List Director Loan Account transactions"
      },
      {
        "method": "POST",
        "path": "/director-loans",
        "desc": "Record a Director Loan Account transaction"
      },
      {
        "method": "GET",
        "path": "/director-loans/balance",
        "desc": "Get DLA running balance per director"
      },
      {
        "method": "GET",
        "path": "/director-loans/balance/:directorId",
        "desc": "Get DLA balance for a single director"
      },
      {
        "method": "GET",
        "path": "/director-loans/s455-exposure",
        "desc": "S455 Corporation Tax exposure summary"
      },
      {
        "method": "POST",
        "path": "/director-loans/snapshot",
        "desc": "Create year-end DLA snapshot with S455 and BiK calculations"
      },
      {
        "method": "GET",
        "path": "/director-loans/snapshots",
        "desc": "List year-end DLA snapshots"
      },
      {
        "method": "GET",
        "path": "/dividends",
        "desc": "List dividends"
      },
      {
        "method": "POST",
        "path": "/dividends",
        "desc": "Declare a dividend for a director"
      },
      {
        "method": "GET",
        "path": "/dividends/board-minutes",
        "desc": "List board minutes"
      },
      {
        "method": "POST",
        "path": "/dividends/board-minutes",
        "desc": "Record board minutes approving a dividend declaration"
      },
      {
        "method": "GET",
        "path": "/dividends/board-minutes/:id",
        "desc": "Get board minutes with associated dividends"
      },
      {
        "method": "GET",
        "path": "/dividends/profit-check",
        "desc": "Check available retained profits for dividend declaration"
      },
      {
        "method": "GET",
        "path": "/dividends/summary",
        "desc": "Dividend summary by financial year"
      },
      {
        "method": "POST",
        "path": "/dividends/tax-calculator",
        "desc": "Calculate UK dividend tax liability"
      },
      {
        "method": "GET",
        "path": "/dividends/:id",
        "desc": "Get dividend details"
      },
      {
        "method": "PATCH",
        "path": "/dividends/:id/pay",
        "desc": "Mark a dividend as paid"
      },
      {
        "method": "POST",
        "path": "/dividends/:id/void",
        "desc": "Void a dividend and reverse its journal entries"
      },
      {
        "method": "GET",
        "path": "/dividends/:id/voucher",
        "desc": "Download dividend voucher as PDF"
      },
      {
        "method": "GET",
        "path": "/board-minutes/:id/pdf",
        "desc": "Download board minutes as PDF"
      }
    ]
  },
  {
    "label": "Import & Migration",
    "slug": "import-&-migration",
    "routes": [
      {
        "method": "GET",
        "path": "/contact-imports",
        "desc": "List contact imports"
      },
      {
        "method": "POST",
        "path": "/contact-imports/upload",
        "desc": "Upload contacts file"
      },
      {
        "method": "GET",
        "path": "/contact-imports/:id",
        "desc": "Get contact import details"
      },
      {
        "method": "DELETE",
        "path": "/contact-imports/:id",
        "desc": "Delete a contact import"
      },
      {
        "method": "POST",
        "path": "/contact-imports/:id/confirm",
        "desc": "Confirm contact import"
      },
      {
        "method": "POST",
        "path": "/contact-imports/:id/resolve",
        "desc": "Resolve identity conflicts"
      },
      {
        "method": "GET",
        "path": "/opening-balances/status",
        "desc": "Get opening balance status"
      },
      {
        "method": "POST",
        "path": "/opening-balances/upload",
        "desc": "Upload opening balances"
      },
      {
        "method": "GET",
        "path": "/opening-balances/:id",
        "desc": "Get opening balance details"
      },
      {
        "method": "DELETE",
        "path": "/opening-balances/:id",
        "desc": "Delete an opening balance import"
      },
      {
        "method": "POST",
        "path": "/opening-balances/:id/confirm",
        "desc": "Confirm opening balances"
      },
      {
        "method": "PATCH",
        "path": "/opening-balances/:id/map",
        "desc": "Map opening balance accounts"
      },
      {
        "method": "POST",
        "path": "/opening-balances/:id/void",
        "desc": "Void opening balances"
      },
      {
        "method": "POST",
        "path": "/invoice-imports/upload",
        "desc": "Upload invoices file"
      },
      {
        "method": "GET",
        "path": "/invoice-imports/:id",
        "desc": "Get invoice import details"
      },
      {
        "method": "DELETE",
        "path": "/invoice-imports/:id",
        "desc": "Delete an invoice import"
      },
      {
        "method": "POST",
        "path": "/invoice-imports/:id/confirm",
        "desc": "Confirm invoice import"
      },
      {
        "method": "POST",
        "path": "/invoice-imports/:id/void",
        "desc": "Void invoice import"
      },
      {
        "method": "POST",
        "path": "/bill-imports/upload",
        "desc": "Upload bills file"
      },
      {
        "method": "GET",
        "path": "/bill-imports/:id",
        "desc": "Get bill import details"
      },
      {
        "method": "DELETE",
        "path": "/bill-imports/:id",
        "desc": "Delete a bill import"
      },
      {
        "method": "POST",
        "path": "/bill-imports/:id/confirm",
        "desc": "Confirm bill import"
      },
      {
        "method": "POST",
        "path": "/bill-imports/:id/void",
        "desc": "Void bill import"
      },
      {
        "method": "POST",
        "path": "/migration",
        "desc": "Create a new migration"
      },
      {
        "method": "GET",
        "path": "/migration/active",
        "desc": "Get active migration"
      },
      {
        "method": "GET",
        "path": "/migration/history",
        "desc": "List migration history"
      },
      {
        "method": "GET",
        "path": "/migration/:id",
        "desc": "Get migration details"
      },
      {
        "method": "DELETE",
        "path": "/migration/:id",
        "desc": "Abandon a migration"
      },
      {
        "method": "POST",
        "path": "/migration/:id/execute",
        "desc": "Execute migration"
      },
      {
        "method": "POST",
        "path": "/migration/:id/upload",
        "desc": "Upload migration data"
      },
      {
        "method": "POST",
        "path": "/migration/:id/upload-deferred",
        "desc": "Upload deferred migration data"
      },
      {
        "method": "POST",
        "path": "/migration/:id/upload-provider",
        "desc": "Upload provider export"
      },
      {
        "method": "POST",
        "path": "/migration/:id/validate",
        "desc": "Validate migration data"
      }
    ]
  },
  {
    "label": "Integration",
    "slug": "integration",
    "routes": [
      {
        "method": "GET",
        "path": "/api-keys",
        "desc": "List API keys"
      },
      {
        "method": "POST",
        "path": "/api-keys",
        "desc": "Create API key"
      },
      {
        "method": "GET",
        "path": "/api-keys/scopes",
        "desc": "List available API key scopes"
      },
      {
        "method": "PATCH",
        "path": "/api-keys/:id",
        "desc": "Update API key name"
      },
      {
        "method": "DELETE",
        "path": "/api-keys/:id",
        "desc": "Revoke API key"
      },
      {
        "method": "POST",
        "path": "/api-keys/:id/rotate",
        "desc": "Rotate API key"
      },
      {
        "method": "GET",
        "path": "/webhooks",
        "desc": "List webhook endpoints"
      },
      {
        "method": "POST",
        "path": "/webhooks",
        "desc": "Create webhook endpoint"
      },
      {
        "method": "PATCH",
        "path": "/webhooks/:id",
        "desc": "Update webhook endpoint"
      },
      {
        "method": "DELETE",
        "path": "/webhooks/:id",
        "desc": "Delete webhook endpoint"
      },
      {
        "method": "GET",
        "path": "/webhooks/:id/deliveries",
        "desc": "Webhook delivery log"
      },
      {
        "method": "POST",
        "path": "/webhooks/:id/rotate",
        "desc": "Rotate webhook signing secret"
      },
      {
        "method": "GET",
        "path": "/api-request-log",
        "desc": "List API request log entries"
      },
      {
        "method": "GET",
        "path": "/api-request-log/:id",
        "desc": "Get API request log entry detail"
      }
    ]
  },
  {
    "label": "Platform",
    "slug": "platform",
    "routes": [
      {
        "method": "POST",
        "path": "/billing/checkout",
        "desc": "Create checkout session"
      },
      {
        "method": "GET",
        "path": "/billing/invoices",
        "desc": "List recent invoices"
      },
      {
        "method": "GET",
        "path": "/billing/plans",
        "desc": "List subscription plans"
      },
      {
        "method": "POST",
        "path": "/billing/portal",
        "desc": "Create billing portal session"
      },
      {
        "method": "GET",
        "path": "/billing/status",
        "desc": "Get billing status"
      },
      {
        "method": "GET",
        "path": "/bug-reports",
        "desc": "List bug reports"
      },
      {
        "method": "POST",
        "path": "/bug-reports",
        "desc": "Submit a bug report"
      },
      {
        "method": "GET",
        "path": "/bug-reports/:id",
        "desc": "Get bug report details"
      },
      {
        "method": "POST",
        "path": "/webhooks/stripe",
        "desc": "Handle Stripe webhook events"
      },
      {
        "method": "GET",
        "path": "/health",
        "desc": "Health check"
      },
      {
        "method": "GET",
        "path": "/transparency/recent",
        "desc": "Recent transparency entries"
      },
      {
        "method": "GET",
        "path": "/transparency/stats",
        "desc": "Transparency statistics"
      },
      {
        "method": "GET",
        "path": "/public/plans",
        "desc": "Get current plan pricing"
      },
      {
        "method": "GET",
        "path": "/public/stats",
        "desc": "Get early access availability"
      },
      {
        "method": "GET",
        "path": "/public/trust",
        "desc": "Get current security trust block"
      }
    ]
  },
  {
    "label": "Admin",
    "slug": "admin",
    "routes": [
      {
        "method": "GET",
        "path": "/admin/audit-log",
        "desc": "View audit log"
      },
      {
        "method": "DELETE",
        "path": "/admin/bug-reports",
        "desc": "Bulk delete bug reports"
      },
      {
        "method": "DELETE",
        "path": "/admin/bug-reports/:id",
        "desc": "Delete a bug report"
      },
      {
        "method": "GET",
        "path": "/admin/orgs",
        "desc": "List organisations"
      },
      {
        "method": "GET",
        "path": "/admin/orgs/:id",
        "desc": "Get organisation details"
      },
      {
        "method": "PATCH",
        "path": "/admin/orgs/:id",
        "desc": "Update organisation"
      },
      {
        "method": "DELETE",
        "path": "/admin/orgs/:id",
        "desc": "Delete organisation (disabled)"
      },
      {
        "method": "POST",
        "path": "/admin/orgs/:id/cancel-subscription",
        "desc": "Cancel subscription"
      },
      {
        "method": "POST",
        "path": "/admin/orgs/:id/deactivate",
        "desc": "Deactivate organisation"
      },
      {
        "method": "POST",
        "path": "/admin/orgs/:id/erase",
        "desc": "Erase organisation (post-window)"
      },
      {
        "method": "POST",
        "path": "/admin/orgs/:id/reactivate",
        "desc": "Reactivate organisation"
      },
      {
        "method": "POST",
        "path": "/admin/orgs/:id/refund",
        "desc": "Refund payment"
      },
      {
        "method": "POST",
        "path": "/admin/orgs/:id/retry-payment",
        "desc": "Retry payment"
      },
      {
        "method": "GET",
        "path": "/admin/search",
        "desc": "Search platform"
      },
      {
        "method": "GET",
        "path": "/admin/settings",
        "desc": "Get platform settings"
      },
      {
        "method": "PATCH",
        "path": "/admin/settings/:key",
        "desc": "Update platform setting"
      },
      {
        "method": "GET",
        "path": "/admin/stats",
        "desc": "Platform statistics"
      },
      {
        "method": "POST",
        "path": "/admin/system/clear-cache",
        "desc": "Clear system cache"
      },
      {
        "method": "GET",
        "path": "/admin/system/health",
        "desc": "System health check"
      },
      {
        "method": "POST",
        "path": "/admin/system/replay-webhooks",
        "desc": "Replay failed webhooks"
      },
      {
        "method": "GET",
        "path": "/admin/system/webhooks/failed",
        "desc": "List failed webhooks"
      },
      {
        "method": "GET",
        "path": "/admin/users",
        "desc": "List users"
      },
      {
        "method": "GET",
        "path": "/admin/users/:id",
        "desc": "Get user details"
      },
      {
        "method": "DELETE",
        "path": "/admin/users/:id",
        "desc": "Delete user"
      },
      {
        "method": "POST",
        "path": "/admin/users/:id/disable-mfa",
        "desc": "Disable user MFA"
      },
      {
        "method": "POST",
        "path": "/admin/users/:id/impersonate",
        "desc": "Impersonate user"
      },
      {
        "method": "PATCH",
        "path": "/admin/users/:id/role",
        "desc": "Update user role"
      },
      {
        "method": "POST",
        "path": "/admin/users/:id/send-reset-link",
        "desc": "Send password reset"
      },
      {
        "method": "POST",
        "path": "/admin/users/:id/suspend",
        "desc": "Suspend user"
      },
      {
        "method": "POST",
        "path": "/admin/users/:id/unlock",
        "desc": "Unlock user"
      },
      {
        "method": "POST",
        "path": "/admin/users/:id/unsuspend",
        "desc": "Unsuspend user"
      },
      {
        "method": "GET",
        "path": "/admin/bug-reports",
        "desc": "List bug reports (admin)"
      },
      {
        "method": "GET",
        "path": "/admin/bug-reports/:id",
        "desc": "Get bug report (admin)"
      },
      {
        "method": "PATCH",
        "path": "/admin/bug-reports/:id",
        "desc": "Update bug report status"
      }
    ]
  }
];

// ---------------------------------------------------------------------------
// Flat path list (for tab autocomplete)
// ---------------------------------------------------------------------------

export const KNOWN_PATHS: string[] = [
  "/accounts",
  "/accounts/:id",
  "/accounts/:id/balance",
  "/accounts/types",
  "/admin/audit-log",
  "/admin/bug-reports",
  "/admin/bug-reports/:id",
  "/admin/orgs",
  "/admin/orgs/:id",
  "/admin/orgs/:id/cancel-subscription",
  "/admin/orgs/:id/deactivate",
  "/admin/orgs/:id/erase",
  "/admin/orgs/:id/reactivate",
  "/admin/orgs/:id/refund",
  "/admin/orgs/:id/retry-payment",
  "/admin/search",
  "/admin/settings",
  "/admin/settings/:key",
  "/admin/stats",
  "/admin/system/clear-cache",
  "/admin/system/health",
  "/admin/system/replay-webhooks",
  "/admin/system/webhooks/failed",
  "/admin/users",
  "/admin/users/:id",
  "/admin/users/:id/disable-mfa",
  "/admin/users/:id/impersonate",
  "/admin/users/:id/role",
  "/admin/users/:id/send-reset-link",
  "/admin/users/:id/suspend",
  "/admin/users/:id/unlock",
  "/admin/users/:id/unsuspend",
  "/api-keys",
  "/api-keys/:id",
  "/api-keys/:id/rotate",
  "/api-keys/scopes",
  "/api-request-log",
  "/api-request-log/:id",
  "/auth/forgot-password",
  "/auth/login",
  "/auth/logout",
  "/auth/me",
  "/auth/password",
  "/auth/refresh",
  "/auth/register",
  "/auth/reset-password",
  "/auth/reset-password/validate",
  "/auth/totp",
  "/auth/totp/enable",
  "/auth/totp/setup",
  "/auth/totp/verify",
  "/auth/verify-email",
  "/auth/verify-email/send",
  "/auth/verify-email/status",
  "/bank-accounts",
  "/bank-imports",
  "/bank-imports/:id",
  "/bank-imports/:id/confirm",
  "/bank-imports/:id/remap",
  "/bank-imports/upload",
  "/bill-imports/:id",
  "/bill-imports/:id/confirm",
  "/bill-imports/:id/void",
  "/bill-imports/upload",
  "/billing/checkout",
  "/billing/invoices",
  "/billing/plans",
  "/billing/portal",
  "/billing/status",
  "/board-minutes/:id/pdf",
  "/bug-reports",
  "/bug-reports/:id",
  "/categorisation-rules",
  "/categorisation-rules/:id",
  "/categorisation-rules/categorise-row",
  "/categorisation-rules/global",
  "/categorisation-rules/reorder",
  "/categorisation-rules/test",
  "/contact-imports",
  "/contact-imports/:id",
  "/contact-imports/:id/confirm",
  "/contact-imports/:id/resolve",
  "/contact-imports/upload",
  "/contacts",
  "/contacts/:id",
  "/contacts/:id/summary",
  "/credit-notes",
  "/credit-notes/:id",
  "/credit-notes/:id/allocations",
  "/credit-notes/:id/allocations/:alloc_id/reverse",
  "/credit-notes/:id/issue",
  "/credit-notes/:id/void",
  "/director-loans",
  "/director-loans/balance",
  "/director-loans/balance/:directorId",
  "/director-loans/s455-exposure",
  "/director-loans/snapshot",
  "/director-loans/snapshots",
  "/directors",
  "/directors/:id",
  "/dividends",
  "/dividends/:id",
  "/dividends/:id/pay",
  "/dividends/:id/void",
  "/dividends/:id/voucher",
  "/dividends/board-minutes",
  "/dividends/board-minutes/:id",
  "/dividends/profit-check",
  "/dividends/summary",
  "/dividends/tax-calculator",
  "/health",
  "/invoice-imports/:id",
  "/invoice-imports/:id/confirm",
  "/invoice-imports/:id/void",
  "/invoice-imports/upload",
  "/invoices",
  "/invoices/:id",
  "/invoices/:id/email",
  "/invoices/:id/payment",
  "/invoices/:id/payment/reverse",
  "/invoices/:id/pdf",
  "/invoices/:id/status",
  "/invoices/preview",
  "/migration",
  "/migration/:id",
  "/migration/:id/execute",
  "/migration/:id/upload",
  "/migration/:id/upload-deferred",
  "/migration/:id/upload-provider",
  "/migration/:id/validate",
  "/migration/active",
  "/migration/history",
  "/opening-balances/:id",
  "/opening-balances/:id/confirm",
  "/opening-balances/:id/map",
  "/opening-balances/:id/void",
  "/opening-balances/status",
  "/opening-balances/upload",
  "/organisation",
  "/organisation/accounting-period",
  "/organisation/accounting-period/preview",
  "/organisation/settings",
  "/public/plans",
  "/public/stats",
  "/public/trust",
  "/quotes",
  "/quotes/:id",
  "/quotes/:id/convert",
  "/quotes/:id/status",
  "/quotes/preview",
  "/reports/aged-creditors",
  "/reports/aged-debtors",
  "/reports/balance-sheet",
  "/reports/dashboard-summary",
  "/reports/ledger-verification",
  "/reports/periods",
  "/reports/periods/:id",
  "/reports/profit-loss",
  "/reports/trial-balance",
  "/reports/vat",
  "/transactions",
  "/transactions/:id",
  "/transactions/:id/categorise",
  "/transactions/:id/reconcile",
  "/transactions/:id/status",
  "/transactions/:id/suggest-category",
  "/transactions/account/:accountId",
  "/transparency/recent",
  "/transparency/stats",
  "/webhooks",
  "/webhooks/:id",
  "/webhooks/:id/deliveries",
  "/webhooks/:id/rotate",
  "/webhooks/stripe"
];

// ---------------------------------------------------------------------------
// ID prefix → resource mapping (for clickable IDs)
// ---------------------------------------------------------------------------

export const ID_PREFIX_TO_RESOURCE: Record<string, string> = {
  "inv": "invoices",
  "cont": "contacts",
  "txn": "transactions",
  "acc": "accounts",
  "cr": "categorisation-rules",
  "qt": "quotes",
  "quo": "quotes",
  "wh": "webhook-endpoints",
  "dir": "directors",
  "dl": "director-loans",
  "div": "dividends",
  "bm": "board-minutes",
  "ba": "bank-accounts",
  "bi": "bank-imports",
  "ob": "opening-balances",
  "ii": "invoice-imports",
  "bli": "bill-imports",
  "ci": "contact-imports",
  "ak": "api-keys",
  "br": "bug-reports",
  "org": "organisation",
  "mig": "migrations",
  "usr": "users",
  "line": "line-items",
  "dimp": "data-imports"
};

// ---------------------------------------------------------------------------
// ID regex pattern (matches all known prefixed IDs)
// Sorted longest-prefix-first to prevent partial matches.
// ---------------------------------------------------------------------------

export const ID_REGEX = /\b(cont|line|dimp|inv|txn|acc|quo|dir|div|bli|org|mig|usr|cr|qt|wh|dl|bm|ba|bi|ob|ii|ci|ak|br)_(\d+)\b/g;

// ---------------------------------------------------------------------------
// Ghost text suggestions (weighted by resource importance)
// ---------------------------------------------------------------------------

export const GHOST_SUGGESTIONS: string[] = [
  "GET /invoices",
  "GET /contacts",
  "GET /transactions",
  "GET /accounts",
  "GET /organisation",
  "GET /api-keys",
  "GET /categorisation-rules",
  "GET /directors",
  "GET /dividends",
  "GET /bank-accounts",
  "GET /bank-imports",
  "GET /quotes",
  "GET /director-loans",
  "POST /contacts {}",
  "POST /invoices {}",
  "POST /transactions {}",
  "POST /categorisation-rules {}",
  "GET /reports/aged-creditors",
  "GET /reports/aged-debtors",
  "GET /reports/balance-sheet",
  "GET /reports/dashboard-summary",
  "GET /reports/ledger-verification",
  "GET /reports/periods",
  "GET /reports/periods/:id",
  "GET /reports/profit-loss",
  "GET /reports/trial-balance",
  "GET /reports/vat"
];

// ---------------------------------------------------------------------------
// Flat route list (convenience export)
// ---------------------------------------------------------------------------

export const ALL_ROUTES: ShellRoute[] = SHELL_CATEGORIES.flatMap(c => c.routes);

// ---------------------------------------------------------------------------
// Stats
// ---------------------------------------------------------------------------

export const ROUTE_COUNT = 216;
export const CATEGORY_COUNT = 8;
